import { Link } from "react-router-dom";
import "./style.css";
import Moment from "react-moment";
import { Dots, Public } from "../../svg";
import ReactsPopup from "./ReactsPopup";
import { useEffect, useRef, useState } from "react";
import CreateComment from "./CreateComment";
import PostMenu from "./PostMenu";
import ShareMenu from "./ShareMenu";
import PostModal from "./PostModal";
import EditPostPopup from "../editPostPopup";
import { getReacts, reactPost } from "../../functions/post";
import Comment from "./Comment";

// Mapa de rotas para cada tipo editorial
const EDITORIAL_FEED_ROUTES = {
  // Video & Social
  tiktok: "/tiktok",
  youtube: "/youtube",
  reels: "/reels",
  shorts: "/shorts",
  netflix: "/netflix",
  gaming: "/gaming",
  audio: "/audio",
  spotify: "/spotify",
  live_audio: "/live-audio",
  live_streaming: "/live-stream",
  movie_portal: "/movie-portal",
  video_bank: "/video-bank",
  threads: "/threads",
  gif: "/gif",
  sticker: "/sticker",
  // News & Content
  cnn: "/cnn",
  blog: "/blog",
  podcast: "/podcast",
  portfolio: "/portfolio",
  library: "/library",
  ebook: "/ebook",
  pdf: "/pdf",
  // Education
  course: "/course",
  quiz: "/quiz",
  tutorial: "/tutorial",
  estudent: "/estudent",
  school: "/school",
  voting: "/voting",
  // Gaming
  esports: "/esports",
  game_review: "/game-review",
  // Commerce
  eshop: "/eshop",
  aliexpress: "/aliexpress",
  restaurant: "/restaurant",
  food_delivery: "/food-delivery",
  booking: "/booking",
  airbnb: "/airbnb",
  rental: "/rental",
  uber: "/uber",
  jobservice: "/job-service",
  event: "/event",
  classified: "/classified",
  // Health & Social
  medical: "/medical",
  ong: "/ong",
  crowdfunding: "/crowdfunding",
  community: "/community",
  petition: "/petition",
  // Wellness & Lifestyle
  travel: "/travel",
  car: "/car",
  yoga: "/yoga",
  exercise: "/exercise",
  recipe: "/recipe",
  fashion: "/fashion",
  beauty: "/beauty",
};

const resolveEditorialFeedPath = (type) => {
  if (!type) return "/feeds";
  return EDITORIAL_FEED_ROUTES[type] || "/feeds";
};
export default function Post({ post: initialPost, user, profile, onShare, dispatch }) {
  const [post, setPost] = useState(initialPost);
  const [visible, setVisible] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [showShareMenu, setShowShareMenu] = useState(false);
  const [showPostModal, setShowPostModal] = useState(false);
  const [showEditPost, setShowEditPost] = useState(false);
  const [reacts, setReacts] = useState();
  const [check, setCheck] = useState();
  const [total, setTotal] = useState(0);
  const [count, setCount] = useState(1);
  const [checkSaved, setCheckSaved] = useState();
  const [comments, setComments] = useState([]);
  const [sharesCount, setSharesCount] = useState(post?.shares?.length || 0);
  const targetEditorialType = post?.sharedPost?.editorialType || post?.editorialType;
  const originalFeedPath = resolveEditorialFeedPath(targetEditorialType);

  // Atualizar post local quando initialPost mudar
  useEffect(() => {
    setPost(initialPost);
  }, [initialPost]);

  // Handler para quando o post é atualizado
  const handlePostUpdated = (updatedPost) => {
    setPost(updatedPost);
    setComments(updatedPost.comments || []);
    // Atualizar no estado global se dispatch estiver disponível
    if (dispatch) {
      dispatch({ type: "UPDATE_POST", payload: updatedPost });
    }
  };
  useEffect(() => {
    getPostReacts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [post]);
  useEffect(() => {
    setComments(post?.comments);
  }, [post]);
  useEffect(() => {
    setSharesCount(post?.shares?.length || 0);
  }, [post]);

  const getPostReacts = async () => {
    const res = await getReacts(post._id, user.token);
    setReacts(res.reacts);
    setCheck(res.check);
    setTotal(res.total);
    setCheckSaved(res.checkSaved);
  };

  const reactHandler = async (type) => {
    reactPost(post._id, type, user.token);
    if (check === type) {
      setCheck();
      let index = reacts.findIndex((x) => x.react === check);
      if (index !== -1) {
        setReacts([...reacts, (reacts[index].count = --reacts[index].count)]);
        setTotal((prev) => --prev);
      }
    } else {
      setCheck(type);
      let index = reacts.findIndex((x) => x.react === type);
      let index1 = reacts.findIndex((x) => x.react === check);
      if (index !== -1) {
        setReacts([...reacts, (reacts[index].count = ++reacts[index].count)]);
        setTotal((prev) => ++prev);
        console.log(reacts);
      }
      if (index1 !== -1) {
        setReacts([...reacts, (reacts[index1].count = --reacts[index1].count)]);
        setTotal((prev) => --prev);
        console.log(reacts);
      }
    }
  };
  const showMore = () => {
    setCount((prev) => prev + 3);
  };
  const postRef = useRef(null);
  return (
    <div
      className="post"
      style={{ width: `${profile && "100%"}` }}
      ref={postRef}
    >
      <div className="post_header">
        <Link
          to={`/profile/${post.user.username}`}
          className="post_header_left"
        >
          <img src={post.user.picture} alt="" />
          <div className="header_col">
            <div className="post_profile_name">
              {post.user.first_name} {post.user.last_name}
              <div className="updated_p">
                {post.type === "profilePicture" &&
                  `updated ${
                    post.user.gender === "male" ? "his" : "her"
                  } profile picture`}
                {post.type === "coverPicture" &&
                  `updated ${
                    post.user.gender === "male" ? "his" : "her"
                  } cover picture`}
              </div>
            </div>
            <div className="post_profile_privacy_date">
              <Moment fromNow interval={30}>
                {post.createdAt}
              </Moment>
              . <Public color="#828387" />
              {post.isEdited && (
                <span className="post_edited_indicator" title={`Atualizado ${new Date(post.editedAt).toLocaleString()}`}>
                  . Editado
                </span>
              )}
            </div>
            {post.isEdited && (
              <div className="post_updated_badge">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 15.5A3.5 3.5 0 1 0 12 8.5a3.5 3.5 0 0 0 0 7z" fill="#fff"/>
                  <path d="M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z" fill="#fff"/>
                </svg>
                <span>Foto atualizada</span>
              </div>
            )}
          </div>
        </Link>
        <div
          className="post_header_right hover1"
          onClick={() => setShowMenu((prev) => !prev)}
        >
          <Dots color="#828387" />
        </div>
      </div>
      {/* Botão para abrir o feed original deste tipo editorial */}
      {originalFeedPath && (
        <Link
          to={originalFeedPath}
          className="post_feed_redirect hover1"
          state={{ initialEditorialType: targetEditorialType, fromProfile: true }}
        >
          <span className="post_feed_redirect_icon">↪</span>
          <span>Ver no feed original</span>
        </Link>
      )}
      {post.type === "share" && post.sharedPost ? (
        <>
          {post.text && <div className="post_text">{post.text}</div>}
          <div className="shared_post">
            <Link
              to={`/profile/${post.sharedPost.user?.username}`}
              className="shared_post_header"
            >
              <img src={post.sharedPost.user?.picture} alt="" />
              <div className="shared_header_col">
                <span className="shared_post_name">
                  {post.sharedPost.user?.first_name}{" "}
                  {post.sharedPost.user?.last_name}
                </span>
                <span className="shared_post_date">
                  <Moment fromNow interval={30}>
                    {post.sharedPost.createdAt}
                  </Moment>
                </span>
              </div>
            </Link>
            {post.sharedPost.background ? (
              <div
                className="shared_post_bg"
                style={{ backgroundImage: `url(${post.sharedPost.background})` }}
              >
                <div className="shared_post_bg_text">{post.sharedPost.text}</div>
              </div>
            ) : (
              <>
                {post.sharedPost.text && (
                  <div className="shared_post_text">{post.sharedPost.text}</div>
                )}
                {post.sharedPost.images && post.sharedPost.images.length > 0 && (
                  <div
                    className="shared_post_images"
                    onClick={() => setShowPostModal(true)}
                    style={{ cursor: "pointer" }}
                  >
                    <img src={post.sharedPost.images[0].url} alt="" />
                  </div>
                )}
              </>
            )}
          </div>
        </>
      ) : post.background ? (
        <div
          className="post_bg"
          style={{ backgroundImage: `url(${post.background})`, cursor: "pointer" }}
          onClick={() => setShowPostModal(true)}
        >
          <div className="post_bg_text">{post.text}</div>
        </div>
      ) : post.type === null ? (
        <>
          <div className="post_text">{post.text}</div>
          {/* Videos */}
          {post.videos && post.videos.length > 0 && (
            <div className="post_videos">
              {post.videos.map((video, i) => (
                <div key={i} className="post_video_container">
                  <video
                    src={video.url}
                    controls
                    poster={video.thumbnail}
                    preload="metadata"
                    className="post_video"
                    onClick={(e) => e.stopPropagation()}
                  >
                    Seu navegador não suporta vídeos.
                  </video>
                </div>
              ))}
            </div>
          )}
          {/* Images */}
          {post.images && post.images.length > 0 && (
            <div
              className={
                post.images.length === 1
                  ? "grid_1"
                  : post.images.length === 2
                  ? "grid_2"
                  : post.images.length === 3
                  ? "grid_3"
                  : post.images.length === 4
                  ? "grid_4"
                  : post.images.length >= 5 && "grid_5"
              }
              onClick={() => setShowPostModal(true)}
              style={{ cursor: "pointer" }}
            >
              {post.images.slice(0, 5).map((image, i) => (
                <img src={image.url} key={i} alt="" className={`img-${i}`} />
              ))}
              {post.images.length > 5 && (
                <div className="more-pics-shadow">
                  +{post.images.length - 5}
                </div>
              )}
            </div>
          )}
        </>
      ) : post.type === "profilePicture" ? (
        <div
          className="post_profile_wrap"
          onClick={() => setShowPostModal(true)}
          style={{ cursor: "pointer" }}
        >
          <div className="post_updated_bg">
            <img src={post.user.cover} alt="" />
          </div>
          <img
            src={post.images[0].url}
            alt=""
            className="post_updated_picture"
          />
        </div>
      ) : post.type === "coverPicture" ? (
        <div
          className="post_cover_wrap"
          onClick={() => setShowPostModal(true)}
          style={{ cursor: "pointer" }}
        >
          <img src={post.images[0].url} alt="" />
        </div>
      ) : null}

      <div className="post_infos">
        <div className="reacts_count">
          <div className="reacts_count_imgs">
            {reacts &&
              reacts
                .sort((a, b) => {
                  return b.count - a.count;
                })
                .slice(0, 3)
                .map(
                  (react, i) =>
                    react.count > 0 && (
                      <img
                        src={`../../../reacts/${react.react}.svg`}
                        alt=""
                        key={i}
                      />
                    )
                )}
          </div>
          <div className="reacts_count_num">{total > 0 && total}</div>
        </div>
        <div className="to_right">
          <div className="comments_count">{comments.length} comments</div>
          <div className="share_count">
            {sharesCount} {sharesCount === 1 ? "share" : "shares"}
          </div>
        </div>
      </div>
      <div className="post_actions">
        <ReactsPopup
          visible={visible}
          setVisible={setVisible}
          reactHandler={reactHandler}
        />
        <div
          className="post_action hover1"
          onMouseOver={() => {
            setTimeout(() => {
              setVisible(true);
            }, 500);
          }}
          onMouseLeave={() => {
            setTimeout(() => {
              setVisible(false);
            }, 500);
          }}
          onClick={() => reactHandler(check ? check : "like")}
        >
          {check ? (
            <img
              src={`../../../reacts/${check}.svg`}
              alt=""
              className="small_react"
              style={{ width: "18px" }}
            />
          ) : (
            <i className="like_icon"></i>
          )}
          <span
            style={{
              color: `
          
          ${
            check === "like"
              ? "#4267b2"
              : check === "love"
              ? "#f63459"
              : check === "haha"
              ? "#f7b125"
              : check === "sad"
              ? "#f7b125"
              : check === "wow"
              ? "#f7b125"
              : check === "angry"
              ? "#e4605a"
              : ""
          }
          `,
            }}
          >
            {check ? check : "Like"}
          </span>
        </div>
        <div className="post_action hover1">
          <i className="comment_icon"></i>
          <span>Comment</span>
        </div>
        <div
          className="post_action hover1"
          onClick={() => setShowShareMenu((prev) => !prev)}
        >
          <i className="share_icon"></i>
          <span>Share</span>
        </div>
        {showShareMenu && (
          <ShareMenu
            postId={post.type === "share" ? post.sharedPost?._id : post._id}
            user={user}
            setShowShareMenu={setShowShareMenu}
            setSharesCount={
              post.type === "share" ? () => {} : setSharesCount
            }
            onShare={onShare}
          />
        )}
      </div>
      <div className="comments_wrap">
        <div className="comments_order"></div>
        <CreateComment
          user={user}
          postId={post._id}
          setComments={setComments}
          setCount={setCount}
        />
        {comments &&
          Array.isArray(comments) &&
          comments
            .sort((a, b) => {
              // Comentários fixados primeiro
              if (a.isPinned && !b.isPinned) return -1;
              if (!a.isPinned && b.isPinned) return 1;
              return new Date(b.commentAt) - new Date(a.commentAt);
            })
            .slice(0, count)
            .map((comment, i) => (
              <Comment
                key={comment._id || i}
                comment={comment}
                postId={post._id}
                user={user}
                setComments={setComments}
                isPostOwner={post.user._id === user.id}
              />
            ))}
        {comments && Array.isArray(comments) && count < comments.length && (
          <div className="view_comments" onClick={() => showMore()}>
            View more comments
          </div>
        )}
      </div>
      {showMenu && (
        <PostMenu
          userId={user.id}
          postUserId={post.user._id}
          imagesLength={post?.images?.length}
          setShowMenu={setShowMenu}
          postId={post._id}
          token={user.token}
          checkSaved={checkSaved}
          setCheckSaved={setCheckSaved}
          images={post.images}
          postRef={postRef}
          onEditPost={() => {
            setShowMenu(false);
            setShowEditPost(true);
          }}
          hasVideos={post?.videos?.length > 0}
        />
      )}
      {showPostModal && (
        <PostModal
          post={post}
          user={user}
          setShowModal={setShowPostModal}
          onShare={onShare}
        />
      )}
      {showEditPost && (
        <EditPostPopup
          post={post}
          user={user}
          setVisible={setShowEditPost}
          onPostUpdated={handlePostUpdated}
        />
      )}
    </div>
  );
}
